import * as React from 'react';
export var AssetPathContext = /*#__PURE__*/React.createContext(function () {
  return '';
});